export default __webpack_public_path__ + "static/media/icono_cerrar.dbe234f4.svg";